export const ORDER_DETAILS_SIDEBAR_TRANSLATION_DE = {
  order_details: 'Auftragsdetails',
  open_planning: 'Planung öffnen',
};
